import { http } from '../utils/http/index'

export class EnterpriseApi {
  // 获取企业列表
  async getCompanyList(params: any) {
    return http.get('/company/getList', params)
  }

  // 企业详情
  async getCompanyDetail(params: any) {
    return http.get('/company-wall/detail', params)
  }

  // 企业墙信息
  async getCompanyWallInfo(params: any) {
    return http.get('/company-wall/editCompanyWallInfo', params)
  }

  // 企业墙信息编辑操作
  async editCompanyWallInfo(params: any) {
    return http.post('/company-wall/editCompanyWallInfo', params)
  }

  // 企业照片列表
  async companyAlbumList(params: any) {
    return http.get('/company/albumList', params)
  }

  // 企业照片添加
  async companyAlbumAdd(params: any) {
    return http.post('/company/albumAdd', params)
  }

  // 企业照片编辑
  async companyAlbumEdit(params: any) {
    return http.post('/company/albumUpdate', params)
  }

  // 企业照片删除
  async companyAlbumDel(params: any) {
    return http.post('/company/albumDel', params)
  }

  // 企业照片详情
  async companyAlbumDetail(params: any) {
    return http.get('/company/albumDetail', params)
  }

  async companyProductList(params: any) {
    return http.get('/parkcompany/companyProductList', params)
  }

  // 企业产品添加
  async companyProductAdd(params: any) {
    return http.post('/parkcompany/addCompanyProduct', params)
  }

  // 企业产品编辑
  async companyProductEdit(params: any) {
    return http.post('/parkcompany/editCompanyProduct', params)
  }

  // 企业产品删除
  async companyProductDel(params: any) {
    return http.delete('/parkcompany/delCompanyProduct', params)
  }

  // 企业产品详情
  async companyProductDetail(params: any) {
    return http.get('/parkcompany/companyProductDetail', params)
  }

  // 申请绑定企业
  async applyBingDingCompany(params: any) {
    return http.post('/apply-bing-ding-company/applyBingDingCompany', params)
  }

  // 获取企业认证状态
  async getBingDingStatus(params: any) {
    return http.get('/auth/getBingDingCompanyStatus', params)
  }

  // 管理员获取绑定申请列表
  async getApplyList(params: any) {
    return http.get('/apply-bing-ding-company/getApplyList', params)
  }

  // 管理员审核用户绑定申请
  async reviewApply(params: any) {
    return http.post('/apply-bing-ding-company/reviewApply', params)
  }

  // 取消企业绑定申请
  async cancelApplyBingDingCompany(params: any) {
    return http.post('/apply-bing-ding-company/cancelApplyBingDingCompany', params)
  }

  // 退出公司操作
  async quitCompany(params: any) {
    return http.post('/auth/quitCompany', params)
  }

  // 无需审核绑定公司操作
  async doBingDingOperate(params: any) {
    return http.post('/apply-bing-ding-company/doBingDingOperate', params)
  }

  // 获取员工列表
  async getPersonnelList(params: any) {
    return http.get('/company/getPersonnelList', params)
  }

  // 获取申请绑定员工数量
  async getApplyCompanyCount(params: any) {
    return http.get('/company/getBingDings', params)
  }

  // 移除员工
  async removePersonnel(params: any) {
    return http.post('/company/removePersonnel', params)
  }

  // 平台服务列表页数据
  async getparkServiceList(params: any) {
    return http.get('/park-service/getList', params)
  }

  // 服务详情
  async getparkServiceDetail(params: any) {
    return http.get('/park-service/detail', params)
  }

  // 提交需求申请
  async getparkServiceApply(params: any) {
    return http.post('/park-service/apply', params)
  }

  // 获取小程序码（免审核绑定公司功能）
  async getMiNiAppQrCode(params: any) {
    return http.get('/apply-bing-ding-company/getMiNiAppQrCode', params)
  }
}
